export const POST_REFER_FRIEND_PROCESS = 'POST_REFER_FRIEND_PROCESS';
export const POST_REFER_FRIEND_START = 'POST_REFER_FRIEND_START';
